import React, { useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import '../assets/index.css'
import '../assets/style.scss'
import Header from './Header'
import Side from './Side'
import Main from './Main'
import { getPeriods, getMenu, getCookteam, BASE_API_URL } from '../api'
import losos from '../assets/img/losos.png';
import {
  getPeriodsForTime,
  parsePeriodsDates,
  getNext,
  getDishesPhotoIds,
  getVersion,
  isHTML,
  getLocalIP,
} from './utils'

function App() {
  const [menu, setMenu] = useState([]);
  const [dishesPhotos, setDishesPhotos] = useState([]);
  const [periods, setPeriods] = useState({
    list: [],
    currentPeriods: '',
    currentVisiblePeriod: '',
  });
  const [time, setTime] = useState(DateTime.local());
  const [cookteam, setCookteam] = useState([]);
  const [version, setVersion] = useState('');
  const [ip, setIP] = useState('');
  const [loading, setLoading] = useState(false);
  const [bg, setBg] = useState('');

  useEffect(() => {
    ;(async () => {
      const v = await getVersion();
      if (v) setVersion(v);

      const periods = parsePeriodsDates(await getPeriods());
      const currentPeriods = getPeriodsForTime(periods, time);
      const menu = currentPeriods[0]
        ? await getMenu(currentPeriods[0], time.toFormat('yyyy-L-dd'))
        : [];
      const cookteam = await getCookteam();

      setPeriods({
        list: periods,
        currentPeriods,
        currentVisiblePeriod: currentPeriods[0],
      })
      setMenu(menu)
      setDishesPhotos(getDishesPhotoIds(menu))
      setCookteam(cookteam)
      setTime(DateTime.local())
      setIP(await getLocalIP())
    })();

    const interval = setInterval(() => {
      setTime(DateTime.local())
      getVersion().then(newVersion => {
        if (newVersion && !isHTML(newVersion)) {
          setVersion(prevVersion => {
            if (prevVersion && newVersion !== prevVersion) {
              window.location.reload()
            }
            return newVersion
          })
        }
      })
    }, 60 * 1000)
    return () => clearInterval(interval)
  }, [])
  
  useEffect(
    () => {
      // const time2 = DateTime.local(2018, 12, 30, 19, 10)
      if(new Date().getHours() === 0 && new Date().getMinutes() === 1) {
        ;(async () => {
          const periods = parsePeriodsDates(await getPeriods());
          const currentPeriods = getPeriodsForTime(periods, time);
          setPeriods({
            list: periods,
            currentPeriods,
            currentVisiblePeriod: currentPeriods[0],
          })
        })();
      }
      if (periods.list.length) {
        const currentPeriods = getPeriodsForTime(periods.list, time);
        const lastPeriod = periods.currentVisiblePeriod;
        const nextPeriod = getNext(currentPeriods, lastPeriod);
        setPeriods({
          list: periods.list,
          currentPeriods,
          currentVisiblePeriod: nextPeriod,
        });
        if (nextPeriod !== lastPeriod) {
          setLoading(true)
          getMenu(nextPeriod, time.toFormat('yyyy-L-dd')).then(menu => {
            setLoading(false)
            setMenu(menu);
            setDishesPhotos(getDishesPhotoIds(menu));
          })
        }
      }
    },
    [time, getPeriodsForTime, parsePeriodsDates]
  );

    useEffect(async() => {
        let url =  `${BASE_API_URL}&action=menubackground&eatperiod=${periods.currentPeriods[0]}`;
        let response = await fetch(url);
        if (response.status !== 404) {
          setBg(response.url)
        } else {
          setBg(losos)
        }
    }, [periods])    

  return (
    <div className="layout">
      <Header periods={periods} />
      <Main menu={menu} loading={loading} periods={periods}/>
      <Side
        time={time}
        cookteam={cookteam}
        dishes={dishesPhotos}
        version={version}
        ip={ip}
      />
      <img 
      src={bg}
      className="bgWrapper" />
    </div>
  )
}

export default App
